import React from "react"
import { Select, View, Grid, Col, Text } from "react-ame-components"

export class SelectExample extends React.Component {
  state = {
    costumerValue: null,
    selectInput: "",
  }
  options = [
    {
      label: "teste 1",
      value: "teste 1",
    },
    {
      label: "teste 2",
      value: "teste 2",
    },
    {
      label: "teste 3",
      value: "teste 3",
    },
    {
      label: "teste 4",
      value: "teste 4",
    },
    {
      label: "teste 5",
      value: "teste 5",
    },
    {
      label: "teste 6",
      value: "teste 6",
    },
  ]

  componentDidMount() {
    this.timeout = setTimeout(() => {
      this.setState({
        costumerValue: {
          label: "teste 3",
          value: "teste 3",
        },
        hint: "Erro: selecione outro valor",
        status: "negative",
      })
    }, 2300)
  }

  render() {
    return (
      <View
        direction="column"
        align="center"
        justify="center"
        marginTop="big">
        <Grid>
          <Col columnSize={{ sm: 1, md: 3 }}></Col>
          <Col columnSize={{ sm: 10, md: 6 }}>
            <View
              backgroundColor="neutral-100"
              padding="big"
              borderRadius="small"
              shadow="level-2"
              direction="column"
              align="center">
              <Text
                fontSize="large"
                lineHeight="large"
                fontWeight="bold">
                Componente [color=primary]Select[/color]
              </Text>
              <View marginBottom="extra-large">
                <Select
                  label="Label do select"
                  placeholder="Field Label"
                  keySelectLabel="label"
                  hint={this.state.hint}
                  status={this.state.status}
                  value={this.state.costumerValue}
                  options={this.options}
                  onChange={e =>
                    this.setState({
                      status: "positive",
                      hint: "Selecionado com sucesso!",
                    })
                  }
                  inputValue={this.state.selectInput}
                />
              </View>
            </View>
          </Col>
          <Col columnSize={{ sm: 1, md: 3 }}></Col>
        </Grid>
      </View>
    )
  }
}
